import { SupplierFilter } from '../models'
import { CreateSupplierDto, UpdateSupplierDto } from '../models/supplier/dto'
import axiosClient from './axiosClient'

const PATH = '/suppliers'

export const supplierApi = {
  getSuppliers: (filter?: SupplierFilter) =>
    axiosClient.get(PATH, {
      params: { ...filter },
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }),

  createSupplier: (supplier: CreateSupplierDto) =>
    axiosClient.post(PATH, supplier, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }),

  updateSupplier: (id: number, supplier: UpdateSupplierDto) =>
    axiosClient.put(`${PATH}/${id}`, supplier, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }),

  deleteSupplier: (id: number) =>
    axiosClient.delete(`${PATH}/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }),
}
